import React from "react";
import { useNavigate } from "react-router-dom";

const collections = [
  {
    title: "New Collection",
    image:
      "https://services.webserviceco.com/inari-server/images/new.png",
    link: "new-arrivals",
  },
  {
    title: "Women",
    image:
      "https://services.webserviceco.com/inari-server/images/women.png",
    link: "Women",
  },
  {
    title: "Men",
    image:
      "https://services.webserviceco.com/inari-server/images/men.png",
    link: "Men",
  },
  {
    title: "Kids",
    image:
      "https://services.webserviceco.com/inari-server/images/kids.png",
    link: "Kids",
  }
];

const OurCollections = () => {
  const navigate = useNavigate();
  const [hero, ...rest] = collections;

  return (
    <section className="py-14 bg-white">
      <div className="max-w-7xl mx-auto px-3 sm:px-4">
        <h2 className="section-heading text-[28px] md:text-[32px] mb-8">
          Shop By Occasion
        </h2>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
          <button
            type="button"
            className="relative min-h-[420px] lg:min-h-full overflow-hidden rounded-2xl bg-transparent p-0 shadow-none text-left"
            onClick={() => navigate(`/${hero.link}`)}
          >
            <img src={hero.image} alt={hero.title} className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
            <span className="absolute bottom-6 left-0 right-0 text-center text-white font-display text-2xl">
              {hero.title}
            </span>
          </button>

          <div className="grid grid-cols-2 gap-3">
            {rest.map((item) => (
              <button
                type="button"
                key={item.title}
                className="relative aspect-[4/3] overflow-hidden rounded-2xl bg-transparent p-0 shadow-none"
                onClick={() => navigate(`/${item.link}`)}
              >
                <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />
                <span className="absolute bottom-4 left-0 right-0 text-center text-white font-display text-lg">
                  {item.title}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default OurCollections;
